<template>
  <div class="upload">
    <el-upload
      drag
      :limit="limitNum"
      :auto-upload="false"
      accept=".xls, .xlsx"
      :action="UploadUrl()"
      :before-upload="beforeUploadFile"
      :on-change="fileChange"
      :on-remove="remove"
      :on-exceed="exceedFile"
      :on-success="handleSuccess"
      :on-error="handleError"
      :file-list="fileList"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M</div> 
    </el-upload>
      <br />
    <div @click="download"  class="download">
    <i class="el-icon-download"></i>
    模板下载
    </div>
    <br />
    <el-button size="small" type="primary" @click="uploadFile">立即上传</el-button>
    
    <div></div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [], // excel文件列表
    };
  },
  methods: {
    download(){
      //  window.open('http://192.168.1.94:9094/static/用户批量导入模板.xls')
       window.open('https://uuct.medbooks.com.cn:9443/static/用户批量导入模板.xls')
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning(
        `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length +
          fileList.length} 个`
      );
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      // console.log(file.raw);
      this.fileList.push(file.raw);
      // console.log(this.fileList);
    },
    //文件移出时
    remove(file) {
      let num = "";
      this.fileList.map((elem, i, arr) => {
        if (elem.uid == file.uid) {
          num = i;
        }
      });
      this.fileList.splice(num, 1);
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      // console.log("before upload");
      // console.log(file);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx") {
        this.$message.warning("只能上传后缀是.xlsx的文件");
      }
      if (size > 10) {
        this.$message.warning("文件大小不得超过10M");
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success("文件上传成功");
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败");
    },
    UploadUrl: function() {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return "";
    },
    uploadFile() {
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件");
      } else {
        let form = new FormData();
        form.append("file", this.fileList[0]);
        form.get("file"); // 此方法可以查看FormData中插入的对象
        // console.log(form.get("file"));
        Axios({
          method: "post",
          url: process.env.VUE_APP_API_URL + "app-user/import",
          headers: {
            "Content-type": "multipart/form-data",
            BookToken: "Bearer " + sessionStorage.getItem("access_token")
          },
          data: form
        }).then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: res.data.message,
              type: "success"
            });
            this.fileList = [];
            this.$emit("finish",res.data.data)
          } else {
            this.$notify({
              title: "警告",
              message: res.data.message,
              type: "warning"
            });
          }
          // console.log(res);
        });
      }
    }
  }
};
</script>
<style>
.download{
  cursor: pointer;
  color: #409EFF;
}
</style>
